"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseLoss = baseLoss;
const mf_utilities_1 = require("mf-utilities");
const mfLosses = {};
for (const nucleotide of ['Amp', 'Tmp', 'Cmp', 'Gmp', 'Ump']) {
    mfLosses[nucleotide] = {
        code: nucleotide.charAt(0),
        diff: (0, mf_utilities_1.mfDiff)('Rmp', nucleotide),
    };
}
for (const nucleotide of ['Damp', 'Dtmp', 'Dcmp', 'Dgmp', 'Dump']) {
    mfLosses[nucleotide] = {
        code: nucleotide.charAt(1).toUpperCase(),
        diff: (0, mf_utilities_1.mfDiff)('Drmp', nucleotide),
    };
}
function baseLoss(nucleotide) {
    // any residue can loose a base
    let results = [];
    for (let key in mfLosses) {
        const base = mfLosses[key];
        if (nucleotide.includes(key)) {
            results.push(`${nucleotide}(${base.diff})$${base.code}*`);
        }
    }
    return results;
}
//# sourceMappingURL=baseLoss.js.map